import React from 'react'
import { AddCircleIcon, SaveIcon, WarningIcon } from '../icons'

import S from './styled'

const TextArea = ({
  name, title, label, text, number,
  onAdd,
  onSave,
  error,
  validateOnBlur = true, validate,
  warnEmpty,
  style,
  onAction,
  actionIcon,
  inverted,
  className,
  ...props
}) => {
  const inputProps = (text || number)({
    name,
    validateOnBlur,
    validate,
  })
  return (
    <S.Input style={style} className={className}>
      {title && <label {...(typeof label === 'function' ? label(name) : {})}>{title}</label>}
      <S.InputContainer error={!!(error || inputProps.error)} inverted={inverted}>
        <textarea {...inputProps} autoComplete="off" {...props}/>
        {onAdd && <S.Icon onClick={onAdd}><AddCircleIcon /></S.Icon>}
        {onSave && <S.Icon onClick={onSave}><SaveIcon /></S.Icon>}
        {warnEmpty && !inputProps.value && <S.Icon><WarningIcon /></S.Icon>}
        {onAction && actionIcon && <S.Icon onClick={onAction}>{actionIcon}</S.Icon>}
      </S.InputContainer>
      {
        (error || inputProps.error) && <S.ErrorLabel>{(error || inputProps.error)}</S.ErrorLabel>
      }
    </S.Input>
  )

}
export default TextArea
